<script setup>
import { inject } from 'vue'
import { messageDelete } from '@/api/api.js'
import { useUserStore } from '@/stores/user.js'
import { storeToRefs } from 'pinia'

const {
  userId
} = storeToRefs(useUserStore())

const message = inject('message')
const close = inject('close')

async function doAction () {
  try {
    const id = userId.value === message?.senderId ? message.receiverId : message.senderId

    await messageDelete({
      messageId: message.messageId,
      userId: id
    })
  } catch (error) {
    console.log(error)
  }

  await new Promise((resolve) => setTimeout(resolve, 500))
  close()
}
</script>

<template>
  <button
    role="menuitem"
    class="flex items-center gap-2.5 px-1 py-3 w-full text-left text-red-500"
    @click="doAction">
    <InlineSvg :src="require('@/assets/fontawesome/regular/trash.svg')" class="w-4 h-4 shrink-0"/>

    {{ $t('common.delete') }}
  </button>
</template>